import { FILE_FETCH_URL_PATH, SOURCE_FILE_PROPERTIES, SOURCE_FILE_TYPES } from 'enums'
import { isString } from 'lodash'

export const getFileTypeById = fileId => {
  if (!fileId || !isString(fileId)) {
    return ''
  }
  const [ fileType, subFileType ] = fileId.split('_')

  return { fileType, subFileType }
}

export const getApiUrlPathByType = type => {
  if (!type || !FILE_FETCH_URL_PATH[type]) {
    return ''
  }

  return FILE_FETCH_URL_PATH[type]
}

export const isMediaFile = fileId => getApiUrlPathByType(
  getFileTypeById(fileId)?.fileType
) === FILE_FETCH_URL_PATH.jsonmedia

export const isTextFile = fileId => SOURCE_FILE_PROPERTIES.TEXTS.DEFAULT.ID === fileId
export const isTransitionFile = fileId => !!Object
  .values(SOURCE_FILE_PROPERTIES.TRANSITIONS)
  .find(item => item.ID === fileId)

export const getSourceFileTypeByFileId = fileId => {
  if (isTextFile(fileId)) {
    return SOURCE_FILE_TYPES.TEXT
  }
  if (isTransitionFile(fileId)) {
    return SOURCE_FILE_TYPES.TRANSITIONS
  }
  return SOURCE_FILE_TYPES.MEDIA
}

export const isSourceFile = fileId => !!getApiUrlPathByType(getFileTypeById(fileId)?.fileType)
